'use strict'

import _reject from 'lodash/reject'
import _without from 'lodash/without'

import css from './wizard.styles.scss'
import template from './wizard.template.pug'

class UserWizardController {
  constructor($filter) {
    'ngInject'
    Object.assign(
      this,
      { $filter },
      {
        filteredTasksites: [],
        selectedTasksites: [],
      },
    )

    if (this.userData) {
      this.selectedTasksites = this.tasksites.filter((tasksite) => this.userData.tasksites.includes(tasksite.code))
    }
    this.userData = this.userData || {}
  }

  change() {
    if (this.permissionsForm.$invalid) return
    this.onChange({ userData: this.userData })
  }

  search() {
    this.filteredTasksites = this.$filter('searchJsonFilter')(this.tasksites, this.searchTerm)
    this.filteredTasksites = _reject(this.filteredTasksites, (tasksite) => this.selectedTasksites.includes(tasksite))
  }

  add(tasksite) {
    this.userData.tasksites = this.userData.tasksites || []
    this.selectedTasksites = this.selectedTasksites || []

    this.selectedTasksites.push(tasksite)
    this.userData.tasksites.push(tasksite.code)
    this.change()
    this.search()
  }

  remove(tasksite) {
    this.selectedTasksites = _reject(this.selectedTasksites, { code: tasksite.code })
    this.userData.tasksites = _without(this.userData.tasksites, tasksite.code)
    this.change()
    this.search()
  }

  toggle(tasksite) {
    this.userData.tasksites = this.userData.tasksites || []
    this.userData.tasksites = this.userData.tasksites.includes(tasksite.code)
      ? _without(this.userData.tasksites, tasksite.code)
      : this.userData.tasksites.concat(tasksite.code)
    this.change()
  }
}

export const umsUserWizard = {
  controller: UserWizardController,
  template: template({ css }),
  bindings: {
    tasksites: '<',
    showDocuments: '<',
    showReports: '<',
    onChange: '&',
    userData: '<?',
  },
}



// WEBPACK FOOTER //
// ./app/users/components/wizard/wizard.component.js